export const PROFESSIONAL_STATUS = Object.freeze({
  REQUESTED: 'REQUESTED',
  ACCEPTED: 'ACCEPTED',
  REJECTED: 'REJECTED',
});

export const ORDER_STATUS = Object.freeze({
  AWAIT_APPROVAL: 'AWAIT_APPROVAL',
  ACCEPTED: 'ACCEPTED',
  REJECTED: 'REJECTED',
  COMPLETED: 'COMPLETED',
  CUSTOMER_CANCELLED: 'CUSTOMER_CANCELLED',
  CANCELLED: 'CANCELLED',
});

export const USER_TYPES = Object.freeze({
  USER: 'USER',
  PROFESSIONAL: 'PROFESSIONAL',
  ADMIN: 'ADMIN',
});

export const SERVICE_NAME = Object.freeze({
  PHOTOGRAPHER_AND_VIDEOGRAPHER: 'PHOTOGRAPHER_AND_VIDEOGRAPHER',
  SOUND_SYSTEM: 'SOUND_SYSTEM',
  CAKE_MAKERS: 'CAKE_MAKERS',
  FASHION_DESIGNER: 'FASHION_DESIGNER',
  CATERING_EVENT: 'CATERING_EVENT',
  DECORATIONS: 'DECORATIONS',
  MAKEUP_ARTIST: 'MAKEUP_ARTIST',
  HENNA_ARTIST: 'HENNA_ARTIST',
});

export const EMAIL_TEMPLATES = Object.freeze({
  VERIFY_EMAIL: 'VERIFY_EMAIL',
  PASSWORD_RESET: 'PASSWORD_RESET',
});
